var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("账户实时监控系统Ddemo")]),_vm._v(" "),_c('button',{on:{"click":_vm.getWebsocket}},[_vm._v("点击请求后台数据")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.dataFromServer))]),_vm._v(" "),_c('div',{staticStyle:{"width":"600px","height":"400px"},attrs:{"id":"chart"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdd9f97","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VivoUserInfo.vue
// module id = null
// module chunks = 